import React from 'react';
import clsx from 'clsx';
import NavigationMenuItem from './NavigationMenuItem';

export const UtilityNavigationLink = ({ item }) => (
  <li key={item.nodeId}>
    <a
      href={item.path}
      className={clsx(
        'navigation-link utility-navigation-link',
        item?.buttonBackgroundColor.toLowerCase()
      )}
    >
      {item.icon && <img className="link-icon" src={item.icon} alt="" width="16" height="16" />}
      <span>{item.name}</span>
    </a>
  </li>
);

const DesktopMenu = ({ logoInverse, headerNavigationItems, utilityNavigationItems }) => (
  <nav className="desktop-navigation">
    <div className="navigation-list-wrapper">
      <a className="main-logo" href="/" aria-label="Go to home page">
        <img src={logoInverse?.directUrl} alt="" />
      </a>
      <ul className="navigation-list main-navigation">
        {headerNavigationItems.map((item) => (
          <NavigationMenuItem item={item} key={item.nodeId} />
        ))}
      </ul>
      <ul className="navigation-list utility-navigation">
        {utilityNavigationItems.map((item) =>
          item.hasSolidBackground ? (
            <UtilityNavigationLink item={item} key={item.nodeId} />
          ) : (
            <NavigationMenuItem item={item} key={item.nodeId} />
          )
        )}
      </ul>
    </div>
  </nav>
);

export default DesktopMenu;
